import { applicationManagerQueries } from '@round/api';
import { useQuery } from '@tanstack/react-query';

const appManagerOptions = applicationManagerQueries.project.options.detail;
const appManagerUtils = applicationManagerQueries.project.utils.detail;

type Config = Pick<ReturnType<typeof appManagerOptions>, 'enabled' | 'refetchOnWindowFocus'>;

export default function useApplicationManagerProject(appManagerProjectId: number | null | undefined, config?: Config) {
    const query = useQuery({
        ...appManagerOptions(appManagerProjectId),
        ...config,
        enabled: !!appManagerProjectId && config?.enabled,
    });

    return {
        data: query.data,
        status: query.status,
        error: query.error,
        utils: appManagerUtils,
    };
}
